import { render, staticRenderFns } from "./SMSCampaignDetails.vue?vue&type=template&id=04e51d12&scoped=true&"
import script from "./SMSCampaignDetails.vue?vue&type=script&lang=js&"
export * from "./SMSCampaignDetails.vue?vue&type=script&lang=js&"
import style0 from "./SMSCampaignDetails.vue?vue&type=style&index=0&id=04e51d12&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04e51d12",
  null
  
)

export default component.exports